export const SPLIT = 'split';
export const UNIFIED = 'unified';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/DiffView/DiffConsts.js